
import { FormLike } from "../mixins/form-like";

export default FormLike.extend({
	methods: {
		submit() {
			this.validate();
			if (this.isValid) {
				this.$emit("submit");
			}
		}
	}
});
